$(document).ready(function() {
  // --- helpers --------------------------------------------------------------

  function getVideoSrc($media) {
    return (
      $media.find('video source[type="video/mp4"]').attr('src') ||
      $media.find('video source[type="video/mp4"]').attr('data-src') ||
      $media.find('video source').attr('src') ||
      $media.find('video source').attr('data-src') ||
      $media.find('video').attr('src') ||
      $media.find('video').attr('data-src') ||
      $media.data('video-src') ||
      ''
    );
  }

  function swapFeaturedMedia($media) {
    if (!$media || !$media.length) return;

    const $featuredImg = $('.product_featured_media_image');        // <img>
    const $featuredVid = $('.product_featured_media_video');  // <video>
    const thumbSrc     = $media.data('img-url-thumb');

    if ($media.hasClass('product_image')) {
      const newSrc = $media.data('img-url');
      if (!newSrc) return;

      const img = new Image();
      img.onload = function() {
        // hide video, clear source, show image
        const v = $featuredVid.get(0);
        if (v && typeof v.pause === 'function') v.pause();
        $featuredVid.hide().find('source').attr('src', '');
        // some browsers cache <video> currentSrc; force unload
        if (v) v.load();

        $featuredImg.attr('src', newSrc).show();
        if (thumbSrc) $('.atc_fixed_content img').attr('src', thumbSrc);
        if (window.updateGalleryButton) window.updateGalleryButton();
        updateOverlapButtonVisibility();
      };
      img.src = newSrc;

    } else if ($media.hasClass('product_video')) {
        const videoSrc = $media.data('video-src') || getVideoSrc($media);
        if (!videoSrc) return;

        const $featuredImg = $('.product_featured_media_image');
        const $featuredVid = $('.product_featured_media_video');
        const vEl = $featuredVid.get(0);

        $featuredImg.hide();
        $featuredVid.find('source').attr('src', videoSrc);
        vEl.muted = true;
        vEl.load();
        $featuredVid.show();
        try { vEl.play(); } catch(e) {}
        if (window.updateGalleryButton) window.updateGalleryButton();
        updateOverlapButtonVisibility();
      }
  }

  function getThumbPrimarySrc($media) {
    if ($media.hasClass('product_image')) {
      return $media.data('img-url') || '';
    }
    if ($media.hasClass('product_video')) {
      return (
        $media.data('video-src') ||
        $media.find('video source[type="video/mp4"]').attr('src') ||
        $media.find('video source').attr('src') ||
        $media.find('video').attr('src') ||
        ''
      );
    }
    return '';
  }


  function getCurrentFeaturedSrc() {
    const $featuredImg = $('.product_featured_media_image');
    const $featuredVid = $('.product_featured_media_video');

    if ($featuredVid.is(':visible')) {
      return (
        $featuredVid.find('source[type="video/mp4"]').attr('src') ||
        $featuredVid.find('source').attr('src') ||
        $featuredVid.attr('src') ||
        ''
      );
    }
    return $featuredImg.attr('src') || '';
  }

  // --- overlap button helpers ---
  function normalizeAsset(u){
    if(!u) return '';
    return String(u).replace(/^https?:/,'').split('?')[0];
  }

  function isFirstThumbActiveDesktop(){
    const $first = $('.product_media:visible').first();
    if(!$first.length) return false;
    const firstSrc =
      ($first.data('video-src')) ||
      ($first.data('img-url')) ||
      (function(){ // fallback to DOM sources if needed
        const s = $first.find('video source[type="video/mp4"]').attr('src')
          || $first.find('video source').attr('src')
          || $first.find('video').attr('src') || '';
        return s;
      })();

    const current = getCurrentFeaturedSrc();
    return firstSrc && current && normalizeAsset(firstSrc) === normalizeAsset(current);
  }

  function hasNextVisibleVideo() {
    const $vis = $('.product_media:visible');
    if ($vis.length < 2) return false;
    const $next = $vis.eq(1);
    return $next.hasClass('product_video') && !!getVideoSrc($next);
  }
  function shouldShowOverlapButton() {
    return isFirstThumbActiveDesktop() && hasNextVisibleVideo();
  }


  function hasNextVisibleVideo() {
    const $vis = $('.product_media:visible');
    if ($vis.length < 2) return false;
    const $next = $vis.eq(1);
    return $next.hasClass('product_video') && !!getVideoSrc($next);
  }

  function shouldShowOverlapButton() {
    return isFirstThumbActiveDesktop() && hasNextVisibleVideo();
  }

  function updateOverlapButtonVisibility() {
    const $btn = $('.desktop_new_gallery .gallery_overlap_button');

    if (shouldShowOverlapButton()) {
      $btn.removeClass('overlap-locked').show();
    } else {
      $btn.addClass('overlap-locked').hide();
    }
  }

  // --- existing setup ----------------------------

  $('.product_media').each(function() {
    var $element = $(this);

    // Clean the data-title
    var title = $element.data('title');
    if (title) {
      var newTitle = title.replace(/'/g, '');
      $element.attr('data-title', newTitle);
    }

    // Preload the high-res image (images only)
    if ($element.hasClass('product_image')) {
      var url = $element.data('img-url');
      if (url) {
        $('<link>', { rel: 'preload', href: url, as: 'image' }).appendTo('head');
      }
    }
  });

  setTimeout(function() {
    calculateThumbWidth();
    scrollGalleryTo(0);

    const $firstVisible = $('.product_media:visible').first();
    if ($firstVisible.length) swapFeaturedMedia($firstVisible);
    if (window.updateGalleryButton) window.updateGalleryButton();
  }, 50);

  let currentOffset = 0;
  let thumbWidth = 0;
  const visibleCount = 7;
  const gap = 10;

  function calculateThumbWidth() {
    const $firstThumb = $('.product_media:visible').first();
    if ($firstThumb.length) {
      const style = window.getComputedStyle($firstThumb[0]);
      const width = $firstThumb[0].getBoundingClientRect().width;
      const marginLeft = parseFloat(style.marginLeft || 0);
      const marginRight = parseFloat(style.marginRight || 0);
      thumbWidth = Math.ceil(width + marginLeft + marginRight);
    }
  }

  function scrollGalleryTo(offset) {
    const $grid = $('.product_thumbnail_grid');
    const visibleThumbs = $grid.children('.product_media:visible');
    const maxOffset = visibleThumbs.length - visibleCount;
    currentOffset = Math.max(0, Math.min(offset, maxOffset));
    $grid.css('transform', `translateX(-${(thumbWidth + gap) * currentOffset}px)`);
  }

  // helper: auto-scroll the thumbnail strip if a clicked thumb is near the edges
  function autoScrollAfterThumbClick($mediaEl) {
    if (!$mediaEl || !$mediaEl.length) return;

    const $visible = $('.product_media:visible');
    const idx = $visible.index($mediaEl[0]);
    if (idx < 0) return;

    const start = currentOffset;
    const end   = currentOffset + visibleCount - 1;

    // same thresholds you had before: last 3 / first 3 visible
    if (idx >= end - 2 && idx < $visible.length - 1) {
      scrollGalleryTo(currentOffset + 1);
    } else if (idx <= start + 2 && currentOffset > 0) {
      scrollGalleryTo(currentOffset - 1);
    }
  }

  // Force-activate thumbs even if video controls/overlays swallow clicks
  (function forceThumbActivation() {
    function handler(e) {
      // left/primary only
      if (e.button != null && e.button !== 0) return;

      const pt = e.changedTouches ? e.changedTouches[0] : e;
      const el = document.elementFromPoint(pt.clientX, pt.clientY);
      if (!el) return;

      const mediaEl = el.closest
        ? el.closest('.product_media')
        : $(el).closest('.product_media').get(0);
      if (!mediaEl) return;

      // we keep preventDefault/stopPropagation to beat video overlays,
      // but we now ALSO run the auto-scroll logic explicitly.
      e.preventDefault();
      e.stopPropagation();

      const $media = $(mediaEl);
      swapFeaturedMedia($media);
      autoScrollAfterThumbClick($media);   // <-- restore the behavior

      return false;
    }

    ['pointerup','click','touchend','mouseup'].forEach(function(type) {
      document.addEventListener(type, handler, { capture: true, passive: false });
    });
  })();

  // still apply the auto-scroll logic.
  $(document).on('click', '.product_media', function() {
    autoScrollAfterThumbClick($(this));
  });


  $(window).on('resize', function() {
    calculateThumbWidth();
    scrollGalleryTo(currentOffset);
  });

  // Force-activate thumbs even if video controls/overlays swallow clicks
  (function forceThumbActivation() {
    function handler(e) {
      // left click / primary pointer only
      if (e.button != null && e.button !== 0) return;

      const pt = e.changedTouches ? e.changedTouches[0] : e;
      const el = document.elementFromPoint(pt.clientX, pt.clientY);
      if (!el) return;

      // find the .product_media wrapper under the pointer
      const mediaEl = el.closest ? el.closest('.product_media') : $(el).closest('.product_media').get(0);
      if (!mediaEl) return;

      e.preventDefault();
      e.stopPropagation();
      swapFeaturedMedia($(mediaEl));
      return false;
    }

    // Use capture so we run before other listeners that may cancel bubbling
    ['pointerup','click','touchend','mouseup'].forEach(function(type) {
      document.addEventListener(type, handler, { capture: true, passive: false });
    });
  })();

  // Swipe on thumbnail strip
  let touchStartX = 0;
  let touchEndX = 0;

  $('.product_thumbnail_grid_wrapper').on('touchstart', function(e) {
    touchStartX = e.originalEvent.touches[0].clientX;
  });

  $('.product_thumbnail_grid_wrapper').on('touchend', function(e) {
    touchEndX = e.originalEvent.changedTouches[0].clientX;
    handleSwipe();
  });

  function handleSwipe() {
    const swipeDistance = touchEndX - touchStartX;
    if (Math.abs(swipeDistance) < 30) return;
    if (swipeDistance < 0) {
      scrollGalleryTo(currentOffset + 1);
    } else {
      scrollGalleryTo(currentOffset - 1);
    }
  }

  // Swipe on main featured area (image/video)
  let mainTouchStartX = 0;
  let mainTouchEndX = 0;

  $('.product_featured_media_image, .product_featured_media_video').on('touchstart', function(e) {
    mainTouchStartX = e.originalEvent.touches[0].clientX;
  });

  $('.product_featured_media_image, .product_featured_media_video').on('touchend', function(e) {
    mainTouchEndX = e.originalEvent.changedTouches[0].clientX;
    handleMainImageSwipe();
  });

  function handleMainImageSwipe() {
    const swipeDistance = mainTouchEndX - mainTouchStartX;
    if (Math.abs(swipeDistance) < 30) return;

    const $thumbs = $('.product_media:visible');
    const currentFeatured = getCurrentFeaturedSrc();

    let currentIndex = -1;
    $thumbs.each(function(index) {
      if (getThumbPrimarySrc($(this)) === currentFeatured) currentIndex = index;
    });

    if (currentIndex === -1) return;

    let newIndex = currentIndex;
    if (swipeDistance < 0 && currentIndex < $thumbs.length - 1) {
      newIndex = currentIndex + 1;
    } else if (swipeDistance > 0 && currentIndex > 0) {
      newIndex = currentIndex - 1;
    }

    if (newIndex !== currentIndex) {
      const $newThumb = $thumbs.eq(newIndex);
      swapFeaturedMedia($newThumb);

      const start = currentOffset;
      const end = currentOffset + visibleCount - 1;

      if (newIndex >= end - 2 && newIndex < $thumbs.length - 1) {
        scrollGalleryTo(currentOffset + 1);
      } else if (newIndex <= start + 2 && currentOffset > 0) {
        scrollGalleryTo(currentOffset - 1);
      }
    }
  }

  // Swatch change → reset strip + set first visible media
  $(document).on('click', '.swatch-element', function () {
    setTimeout(function() {
      calculateThumbWidth();
      scrollGalleryTo(0);

      const $firstVisible = $('.product_media:visible').first();
      if ($firstVisible.length) swapFeaturedMedia($firstVisible);
    }, 50);
  });

  // Swatch change → reset strip + set first visible media
  $(document).on('click', '.scroll_select_variants .product-variant', function () {
    setTimeout(function() {
      calculateThumbWidth();
      scrollGalleryTo(0);

      const $firstVisible = $('.product_media:visible').first();
      if ($firstVisible.length) swapFeaturedMedia($firstVisible);
    }, 50);
  });

  // Lazy-load thumb videos only when they enter the strip viewport
  (function initThumbVideoLazyLoad() {
    const rootEl = document.querySelector('.product_thumbnail_grid_wrapper') || null;

    const io = new IntersectionObserver((entries) => {
      entries.forEach((en) => {
        const el = en.target;
        const $wrap = $(el);
        const $vid = $wrap.find('video.thumb_video');

        if (!en.isIntersecting) {
          // Pause when out of view
          const v = $vid.get(0);
          if (v) v.pause();
          return;
        }

        // In view: attach source if missing, then play
        if ($vid.find('source').length === 0) {
          const src = $wrap.data('video-src');
          if (src) {
            $vid.append(`<source src="${src}" type="video/mp4">`);
            const v = $vid.get(0);
            v.muted = true;
            v.preload = 'metadata';
            v.load();
            v.play().catch(() => {});
          }
        } else {
          const v = $vid.get(0);
          if (v) v.play().catch(() => {});
        }
      });
    }, { root: rootEl, threshold: 0.25 });

    $('.product_media.product_video').each(function() { io.observe(this); });
  })();


  // --- Fixed Gallery logic --------------------------------------

  function checkProductUpperHeight() {
    var $upperProduct = $('.product_upper .product_upper_right');
    var $innerGallery = $('.desktop_new_gallery');

    var upperProductHeight = $upperProduct.outerHeight();
    var galleryHeight = $innerGallery.outerHeight();

    var shouldFix = upperProductHeight >= galleryHeight;

    $innerGallery.toggleClass('fixed_gallery', shouldFix);

    if (!shouldFix) {
      $innerGallery.removeAttr('style');
    }

    if (shouldFix) {
      $upperProduct.css('position', 'relative');

      $(window).off('scroll.fixedGallery').on('scroll.fixedGallery', function() {
        var scrollTop = $(window).scrollTop();
        var headerOffset = 142.19;

        var upperOffsetTop = $upperProduct.offset().top;
        var maxTop = upperProductHeight - galleryHeight;
        var galleryTop = scrollTop + headerOffset;

        if (galleryTop >= upperOffsetTop + maxTop) {
          var currentWidth = $innerGallery.outerWidth();
          $innerGallery.css({
            position: 'absolute',
            top: maxTop + 'px',
            bottom: 'auto',
            width: currentWidth + 'px'
          });
        } else {
          $innerGallery.css({
            position: 'fixed',
            top: headerOffset + 'px',
            bottom: 'auto'
          });
        }
      });

      $(window).trigger('scroll.fixedGallery');
    } else {
      $(window).off('scroll.fixedGallery');
      $innerGallery.css({ position: '', top: '', bottom: '' });
    }
  }

  checkProductUpperHeight();

  function lockInitialGalleryWidth() {
    const $innerGallery = $('.desktop_new_gallery');
    const $parent = $innerGallery.parent();
    const lockedWidth = $parent.width();
    $innerGallery.css('width', lockedWidth + 'px');
    $innerGallery.data('initial-width-locked', true);
  }

  lockInitialGalleryWidth();

  const observerTarget = document.querySelector('.product_upper .product_upper_right');

  if (observerTarget) {
    const observer = new MutationObserver(() => {
      checkProductUpperHeight();
    });

    observer.observe(observerTarget, {
      childList: true,
      subtree: true,
      attributes: true
    });
  }

  $(window).on('resize', function() {
    checkProductUpperHeight();

    const $innerGallery = $('.desktop_new_gallery');

    if ($innerGallery.hasClass('fixed_gallery') || $innerGallery.css('position') === 'absolute') {
      const newWidth = $innerGallery.parent().width();
      $innerGallery.css('width', newWidth + 'px');
    } else {
      $innerGallery.css('width', '');
    }
  });

  $(window).on('scroll.earlyCheck', function() {
    checkProductUpperHeight();
    $(window).off('scroll.earlyCheck');
  });

  // Click: jump to next VISIBLE media (image or video), wrapping around
  $(document)
    .off('click.nextVisible', '.desktop_new_gallery .gallery_overlap_button')
    .on('click.nextVisible', '.desktop_new_gallery .gallery_overlap_button', function (e) {
      e.preventDefault();

      const $btn = $(this);
      $btn.addClass('overlap-locked').hide();

      const $visible = $('.product_thumbnail_grid .product_media:visible');
      if (!$visible.length) return;

      const current = normalizeAsset(getCurrentFeaturedSrc());
      let currentIdx = -1;

      // find index of the currently-featured media among visible thumbs
      for (let i = 0; i < $visible.length; i++) {
        const cand = normalizeAsset(getThumbPrimarySrc($visible.eq(i)));
        if (cand && cand === current) { currentIdx = i; break; }
      }

      // if not found (e.g., after variant switch), start from the first visible
      const nextIdx = (currentIdx >= 0 ? (currentIdx + 1) % $visible.length : 0);
      const $target = $visible.eq(nextIdx);

      swapFeaturedMedia($target);

      // keep the target thumb in view like your thumb-click logic
      const start = currentOffset;
      const end = currentOffset + visibleCount - 1;
      if (nextIdx >= end - 2 && nextIdx < $visible.length - 1) {
        scrollGalleryTo(currentOffset + 1);
      } else if (nextIdx <= start + 2 && currentOffset > 0) {
        scrollGalleryTo(currentOffset - 1);
      }

      updateOverlapButtonVisibility();
    });


});